// Coins (in-game currency) — pure utility, no framework deps

import { getItem, setItem } from './storage.js';

const STORAGE_KEY = 'minesweeper_coins';
export const START_AMOUNT = 1000;

function load()
{
    const raw = getItem( STORAGE_KEY );
    if ( raw === null ) return null;
    const n = parseInt( raw, 10 );
    if ( !Number.isFinite( n ) || n < 0 ) return null;
    return n;
}

function save( amount )
{
    setItem( STORAGE_KEY, String( amount ) );
}

/**
 * Get current coin balance. Initializes to START_AMOUNT on first call.
 */
export function getCoins()
{
    const stored = load();
    if ( stored === null )
    {
        save( START_AMOUNT );
        return START_AMOUNT;
    }
    return stored;
}

/**
 * Add coins to the balance and persist. Returns new balance.
 */
export function addCoins( amount )
{
    if ( !Number.isFinite( amount ) || amount <= 0 ) return getCoins();
    const next = getCoins() + Math.floor( amount );
    save( next );
    return next;
}

/**
 * Spend coins if affordable. Returns true on success, false if insufficient balance.
 */
export function spendCoins( amount )
{
    if ( !Number.isFinite( amount ) || amount <= 0 ) return true;
    const cost = Math.floor( amount );
    const balance = getCoins();
    if ( balance < cost ) return false;
    save( balance - cost );
    return true;
}
